import React from 'react';
import { FloatingNav } from '../components/FloatingNav';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { ModulesSection } from '../components/ModulesSection';
import { PricingSection } from '../components/PricingSection';
import { BeforeAfter } from '../components/BeforeAfter';
import { DifferentiationSection } from '../components/DifferentiationSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCta } from '../components/FinalCta';
import { FaqSection } from '../components/FaqSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
import { MusicalNotesBackground } from '../components/MusicalNotesBackground';
export function LandingPage() {
  return <>
      <MusicalNotesBackground data-id="element-345" />
      <FloatingNav data-id="element-346" />
      <main className="w-full min-h-screen smooth-scroll relative z-10" data-id="element-347">
        <Hero data-id="element-348" />
        <ProblemSection data-id="element-349" />
        <ModulesSection data-id="element-350" />
        <PricingSection data-id="element-351" />
        <BeforeAfter data-id="element-352" />
        <DifferentiationSection data-id="element-353" />
        <GuaranteeSection data-id="element-354" />
        <FinalCta data-id="element-355" />
        <FaqSection data-id="element-356" />
      </main>
      <Footer data-id="element-357" />
      <PurchaseNotifications data-id="element-358" />
    </>;
}